import React from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Settings, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useAuth } from '@/providers/AuthProvider';
import { useTranslation } from 'react-i18next';
import { useDirection } from '@/providers/DirectionProvider';

interface MobileProfileButtonProps {
  onLogout: () => void;
}

const MobileProfileButton: React.FC<MobileProfileButtonProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();
  const { direction } = useDirection();

  if (!user) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="text-blue-700 hover:text-blue-800 hover:bg-blue-50"
        onClick={() => navigate('/login')}
      >
        <User size={18} />
        <span className={direction === 'rtl' ? 'mr-1' : 'ml-1'} style={{ fontSize: '0.875rem' }}>{t('header.login')}</span>
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="text-blue-700 hover:text-blue-800 hover:bg-blue-50"
          aria-label={t('mobileProfile.profile')}
        >
          <User size={18} />
          <span className={direction === 'rtl' ? 'mr-1' : 'ml-1'} style={{ fontSize: '0.875rem' }}>{t('mobileProfile.profile')}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className={`w-48 bg-white ${direction === 'rtl' ? 'text-right' : 'text-left'}`}>
        <DropdownMenuItem onClick={() => navigate('/settings')}>
          <Settings className={`h-4 w-4 ${direction === 'rtl' ? 'ml-2' : 'mr-2'}`} />
          <span>{t('mobileProfile.settings')}</span>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onLogout} className="text-red-600">
          <LogOut className={`h-4 w-4 ${direction === 'rtl' ? 'ml-2' : 'mr-2'}`} />
          <span>{t('header.logout')}</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MobileProfileButton;